(() => {
  if (window.polewardLocalizationMoverInitialized) return;
  window.polewardLocalizationMoverInitialized = true;
  const mobileMedia = window.matchMedia('(max-width: 989px)');
  const movers = new Map();

  const initializeLocalizationMover = (root = document) => {
    const desktopTarget = root.querySelector('[data-localization-desktop-target]')
      || root.querySelector('poleward-region-drawer')?.desktopTarget;
    const mobileTarget = root.querySelector('[data-localization-mobile-target]');

    if (!desktopTarget || !mobileTarget || movers.has(desktopTarget)) return;

    const forms = [...new Set([
      ...desktopTarget.querySelectorAll(':scope > localization-form'),
      ...mobileTarget.querySelectorAll(':scope > localization-form'),
    ])];
    if (!forms.length) return;

    const moveForms = () => {
      const drawerActive = desktopTarget.dataset.localizationInDrawer === 'true';
      const target = mobileMedia.matches && !drawerActive ? mobileTarget : desktopTarget;
      forms.forEach((form) => {
        if (form.parentElement === target) return;
        if (form.querySelector('.localization-form__select[aria-expanded="true"]')) form.hidePanel?.();
        target.append(form);
      });
    };

    movers.set(desktopTarget, { mobileTarget, moveForms });
    mobileMedia.addEventListener('change', moveForms);
    moveForms();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeLocalizationMover(), { once: true });
  } else {
    initializeLocalizationMover();
  }

  document.addEventListener('shopify:section:load', (event) => initializeLocalizationMover(event.target));
  document.addEventListener('poleward:localization-drawer-change', (event) => {
    movers.get(event.detail?.target)?.moveForms();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    movers.forEach(({ mobileTarget, moveForms }, desktopTarget) => {
      if (!event.target.contains(mobileTarget)) return;
      mobileMedia.removeEventListener('change', moveForms);
      movers.delete(desktopTarget);
    });
  });
})();
